import { Injectable } from '@angular/core';
import { Computer } from './GI.Web.Services.g';

@Injectable()
export class RdpService {
    constructor() {}

    public buildRdpFileAsString(computer:Computer, userName:string):string {
        return "full address:s:" + computer.ipAddress + ":3389\r\n" +
                "username:s:" + computer.computerName + "\\" + userName + "\r\n" +
                "prompt for credentials:i:0\r\n" +
                "drivestoredirect:s:*\r\n" +
                "administrative session:i:1";
    }

    public setRdpFileName(computer:Computer): string {
        var ipAddessparts = computer.ipAddress.split(".");
        if (ipAddessparts[0].length>3){ //dns ipaddress
            return ipAddessparts[0] + ".rdp";
        } else {
            return computer.computerName + ".rdp";
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/rdp.service.ts